<template>
  <!-- 理赔管理 -->
  <div class="main-container">
    <div class="content">
      <Tabs v-model="claimsState" :animated="false" @on-click="searchAjax()">
        <TabPane label="待处理" name="0"></TabPane>
        <TabPane label="处理中" name="2"></TabPane>
        <TabPane label="已处理" name="1"></TabPane>
      </Tabs>
      <div class="search-box">
        <div class="input-item">
          <span class="label">保单号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">联系人</span>
          <Input v-model="searchParams.contactName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">出险产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">出单机构/团队</span>
          <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange" style="height:30px;">
          </selectTree>
        </div>
        <div class="input-item">
          <span class="label">业务员</span>
          <Select v-model="searchParams.salesmanId" filterable transfer clearable>
            <Option v-for="(item, i) in userList" :key="i" :value="item.id">
              <i class="dian" :class="{'red': item.workingState == 0 ,'orange':item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </Select>
        </div>
        <!-- 已处理状态才显示 -->
        <div class="input-item" v-if="claimsState==1">
          <span class="label">理赔结果</span>
          <RadioGroup v-model="searchParams.claimsResult" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="1">理赔成功</Radio>
            <Radio label="0">理赔失败</Radio>
          </RadioGroup>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>
      <div class="tools-box right">
        <Button type="warning" @click="$refs.formModalStep1.open()" v-if="$units.pointAction('workOrder_1_1')">新增</Button>
        <Button type="primary" ghost @click="daochu()" v-if="$units.pointAction('workOrder_1_3')">导出</Button>
        <Button type="primary" ghost @click="importData()" v-if="$units.pointAction('workOrder_1_2')">导入</Button>
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" v-if="tableData.length">
          <template slot-scope="{ row }" slot="contactMobile">
            <div>
              <span v-if="row.eyeShow">{{ row.contactMobile1 }}</span>
              <span v-else>{{ row.contactMobile }}</span>
              <span v-show="row.contactMobile">
                <i class="iconfont iconxianshi eye-icon eye" v-if="row.eyeShow" @click="openEye(row)"></i>
                <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(row)"></i>
              </span>
            </div>
          </template>
          <!-- 操作栏 -->
          <template slot-scope="{ row }" slot="action">
            <Tooltip :content="claimsState==1?'在线理赔已结束，无法更改':'在线理赔中，无法更改'"
              v-if="row.sourceType==2" :transfer="true" placement="top">
              <span class="table-btn disabled" v-if="claimsState == 0">处理中</span>
              <span class="table-btn disabled" v-if="claimsState == 0||claimsState == 2">已处理</span>
              <span class="table-btn disabled" v-else-if="claimsState == 1">修改</span>
            </Tooltip>
            <template v-else>
              <span class="table-btn" :class="{'disabled':row.sourceType==2}" v-if="claimsState == 0" @click="processing(row)">处理中</span>
              <span class="table-btn" :class="{'disabled':row.sourceType==2}" v-if="claimsState == 0||claimsState == 2" @click="showEdit(row)">已处理</span>
              <span class="table-btn" :class="{'disabled':row.sourceType==2}" v-else-if="claimsState == 1" @click="showEdit(row)">修改</span>
            </template>
            <span class="table-btn" @click="del(row)">删除</span>
          </template>
        </Table>
        <no-data v-else style="margin-top:250px;"></no-data>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList"
          style="text-align: center" v-if="tableData.length" />
      </div>

      <!-- 新增表单 有2步 -->
      <form-modal-step1 ref="formModalStep1" @reload="searchAjax()"></form-modal-step1>
      <!-- 编辑表单 只有1步-->
      <form-modal-step2 ref="formModalStep2" @reload="searchAjax()"></form-modal-step2>
      <!-- 确认弹窗 -->
      <confirm-Modal ref="confirmModal"></confirm-Modal>
      <!-- 导入 -->
      <import-tool ref="importTool" @success="searchAjax()"></import-tool>
    </div>
  </div>
</template>

<script>
import { pageTool,common } from "@/api/mixins";
import importTool from '@/components/commons/importTool/index2'
import selectTree from '@/components/system/selectTree3';
import formModalStep1 from './components/formModalStep1';
import formModalStep2 from './components/formModalStep2';
import confirmModal from '@/components/commons/confirmModal';
import { config } from './index.config.js';
export default {
  mixins: [pageTool, config,common],
  components: { selectTree,formModalStep1,formModalStep2,confirmModal,importTool },
  props: {},
  data() {
    return {
      claimsState: "0",// 待处理0 处理中2 已处理1
      searchParams: {},
      userList:[],//业务员列表
      userInfo: {},//登录用户信息
    };
  },
  activated(){
    this.getUserList();
    this.getList()
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.initListAjax("/buz/orderCompensation/read/list")
    
  },
  methods: {    
    openEye(row) {
      if(!row.eyeShow){
        this.descrypt({
          query:row.id,
          operationFunction:21,
          operationType:2,
        },row, 'contactMobile1').then(()=>{
          this.$set(row,'eyeShow',true);
        })
      }else{
        this.$set(row,'eyeShow',false);
      }
    },
    setReqParams(params){
      params.apiPermissionCode = 'workOrder_1_0';
    },
    // 导出
    daochu(){
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.$units.downloadFile("/buz/orderCompensation/batch/export ", params, 'POST', '', 'workOrder_1_3');
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {//机构
        this.searchParams.orgId = data.id;
        this.searchParams.groupId = "";
      } else if (data.nodeType == 2) {//团队
        this.searchParams.orgId = "";
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.orgId = "";
        this.searchParams.groupId = "";
      }
    },
    setListParams(params) {
      this.getColumns();
      params.claimsState = this.claimsState
      if(this.claimsState != 1) {// 不是已处理状态去掉处理结果
        delete params.claimsResult;
      }
    },
    // 获取当前机构业务员
    getUserList() {
      this.$http({
        url: '/buz/userBase/getSubUser',
        type: 'get',
        data: {
          orgId: this.userInfo.organId,
        },
      }).then((res) => {
        this.userList = res.data;
      })
    },
    // 已受理 或 修改
    showEdit(item) {
      const data = JSON.parse(JSON.stringify(item));
      data.claimsState = '1';
      data.formType = 2;
      this.$refs.formModalStep2.open(data);
    },
    // 处理中
    processing(item){
      this.$http({
        url: "/buz/orderCompensation/moveStatus",
        type: "post",
        data: {
          claimsState: 2,
          id: item.id
        }
      }).then(res => {
        this.$notice.success("操作成功");
        this.getList();
      });
    },
    // 删除
    del(item) {
      this.$refs.confirmModal.open({
        title:"提示",
        content:"确定删除？",
      }).then(() => {
        this.$http({
          url: "/buz/orderCompensation/del",
          type: "get",
          data: {
            id: item.id
          }
        }).then(res => {
          this.$notice.success("删除成功");
          this.getList();
        });
      }).catch(()=>{
        
      });
    },
    // 导入
    importData(){
      const dic = JSON.parse(localStorage.dic)['b_order_compensation_export']
      const key = Object.getOwnPropertyNames(dic)[0];
      this.$refs.importTool.open({
        params:{},
        uploadParams:{},
        template:key,
        templateName:dic[key],
        uploadUrl:"/buz/orderCompensation/batch/upload",
        errorUrl:"/buz/orderCompensation/exportError",
        apiPermissionCode:'workOrder_1_2'
      })
    },


  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
